import { createSelector } from '@ngrx/store';
import { State } from './model';

export const selectEntireState = createSelector<State, [State], State>(s => s, s => s);
